import React from "react";
import { useAppContext } from "../../../context/appContext";
import { TextMd, TextSm } from "../../../components/text";
import { SeeMore } from "../../home/components/seeMore";

export const CloudArchitecture = ({ className = "" }) => {
  const { routing } = useAppContext();
  const { navigate } = routing;

  return (
    <button className={`w-full flex flex-col items-center gap-8 text-left ${ className }`}>
      <div className="w-full flex flex-col">
        <TextSm className="uppercase whitespace-nowrap tracking-[0.1em] text-blue-500 font-semibold">
          Cloud Architecture
        </TextSm>

        <TextMd className="font-semibold text-slate-900 mb-4">
          Designing infrastructure that supports growth and reliability.
        </TextMd>

        <TextSm className="text-slate-500 leading-7 mb-8">
          Cloud architecture provides the foundation for scalable applications,
          secure deployments, automated workflows, and systems that can grow
          with your business.
        </TextSm>

        <div className="flex flex-wrap gap-x-8 gap-y-3">
          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>AWS Deployment</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Scalable Infrastructure</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Cloud Data Storage</TextSm>
          </div>
        </div>
      </div>
    </button>
  );
};
